require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./bend-officer-resilience-program.json") })
        }
      }, "path---bend-officer-resilience-program");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---bend-officer-resilience-program!./.cache/json/bend-officer-resilience-program.json
// module id = 841
// module chunks = 231608221292675